import React, { useState, useEffect } from "react";
import { Row, Col, Tabs, Badge } from "antd";
import { Wrapper } from "./styles";
import Colors from '../../theme/colors'
import useManufacturingOrder from '../../hooks/useManufacturingOrder';
import RenderFurnace from './furnace';
import RenderQuenching from './quenching';
import RenderQuality from './quality';
import { useTranslation } from 'react-i18next';

const { TabPane } = Tabs;
const INITIAL_QUENCHING = {
  bath_type: "water",
  bath_temperature: 50,
  agitation_level: 1
}

const RenderControlProcess = ({ changeTitle }) => {
  const [countFurnace, setCountFurnace] = useState(0);
  const [countQuenching, setCountQuenching] = useState(0);
  const [quenchingStatus] = useState(INITIAL_QUENCHING);
  const { manufacturingOrder } = useManufacturingOrder();
  const { t } = useTranslation();

  useEffect(() => {
    changeTitle && changeTitle("control_process");
  }, [changeTitle]);

  useEffect(() => {
    const filtered = manufacturingOrder.filter((order, i) => order.desing);
    let nFurnace = 0, nQuenching = 0
    filtered.forEach((order, i) => {
      order.pieces.forEach((piece, x) => {
        if(piece.furnace && piece.furnace.start && !piece.furnace.end) nFurnace++;
        if(piece.quenching && piece.quenching.start && !piece.quenching.end) nQuenching++;
      });
    });
    setCountFurnace(nFurnace)
    setCountQuenching(nQuenching)
  }, [manufacturingOrder]);

  return (
    <Wrapper>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={24} lg={24} md={24}>
              <Tabs defaultActiveKey="1" >
                <TabPane tab={<span>{t('phase.warm_up')+" - "+t('phase.forja')} <Badge count={countFurnace} style={{ backgroundColor: Colors.primary }} /></span>} key="1">
                  <RenderFurnace quenchingStatus={quenchingStatus} />
                </TabPane>
                <TabPane tab={<span>{t('phase.quenching')} <Badge count={countQuenching} style={{ backgroundColor: Colors.primary }} /></span>} key="2">
                  <RenderQuenching quenchingStatus={quenchingStatus} />
                </TabPane>
                <TabPane tab={<span>{t('phase.quality')} <Badge style={{ backgroundColor: Colors.primary }} /></span>} key="4">
                <RenderQuality quenchingStatus={quenchingStatus} />
                </TabPane>
              </Tabs>
            </Col>
        </Row>
    </Wrapper>
  );
};
export default RenderControlProcess;
